import Email from "components/email";
import NextLink from "next/link";
import { NextSeo } from "next-seo";
export default function Privacy() {
  return (
    <>
      <NextSeo
        title="Privacy Policy"
        description={
          "We take your privacy seriously. We will never sell your information. We use minimal tracking metrics (just so we can see how many people are visiting our site.)"
        }
      />
      <section
        id="privacy-policy"
        className="p-6 mx-auto space-y-6 text-justify lg:max-w-screen-xl sm:p-12 max-w-screen"
      >
        <div className="space-y-4 text-center">
          <h1 className="text-4xl">Privacy Notice</h1>
          <p className="text-xl">Last updated 1 June, 2021</p>
        </div>
        <div className="space-y-4">
          <p>
            Thank you for choosing to be part of our community at 
            <strong>
              {process.env.NEXT_PUBLIC_OG_PROFILE_FIRST_NAME}{" "}
              {process.env.NEXT_PUBLIC_OG_PROFILE_LAST_NAME}
            </strong>
            , doing business as 
            <strong>
              {process.env.NEXT_PUBLIC_SITE_NAME} (&quot;
              {process.env.NEXT_PUBLIC_SITE_NAME}&quot;, &quot;we&quot;,
              &quot;us&quot;, &quot;our&quot;)
            </strong>
            . We are committed to protecting your personal information and your
            right to privacy.
          </p>
          <p>
            If you have any questions or concerns about this privacy notice, or
            our practices with regards to your personal information, please
            contact us at 
            <strong>
              <Email className="text-indigo-800 dark:text-indigo-200 hover:opacity-60" />
            </strong>
            .
          </p>
          <p>
            When you visit our website 
            <strong>
              {process.env.NEXT_PUBLIC_URL ||
                process.env.NEXT_PUBLIC_VERCEL_URL}
               (the &quot;Website&quot;)
            </strong>
            , and more generally, use any of our <strong>services</strong> (
            <strong>the &quot;Services&quot;</strong>, which include
            the Website) , we appreciate that you are trusting us with your
            personal information. We take your privacy very seriously.
          </p>
          <p>
            In this privacy notice, we seek to explain to you in the clearest
            way possible what information we collect, how we use it and what
            rights you have in relation to it. We hope you take some time to
            read through it carefully, as it is important. If there are any
            terms in this privacy notice that you do not agree with, please
            discontinue use of our Services immediately. This privacy notice
            applies to all information collected through our Services (which, as
            described above, includes our Website), as well as, any related
            services, sales, marketing or events.
          </p>
          <p className="font-extrabold underline">
            Please read this privacy notice carefully as it will help you
            understand what we do with the information that we collect.
          </p>
        </div>
        <div className="space-y-4" role="navigation">
          <h2 className="text-3xl text-center">TABLE OF CONTENTS</h2>
          <ul className="mx-auto space-y-2 max-w-max text">
            <li>
              1.{" "}
              <NextLink href="/privacy#privacy-item-1" preload={false}>
                <a className="text-indigo-800 dark:text-indigo-200 hover:opacity-60">
                  WHAT INFORMATION DO WE COLLECT?
                </a>
              </NextLink>
            </li>
            <li>
              2.{" "}
              <NextLink href="/privacy#privacy-item-2" preload={false}>
                <a className="text-indigo-800 dark:text-indigo-200 hover:opacity-60">
                  HOW DO WE USE YOUR INFORMATION?
                </a>
              </NextLink>
            </li>
            <li>
              3.{" "}
              <NextLink href="/privacy#privacy-item-3" preload={false}>
                <a className="text-indigo-800 dark:text-indigo-200 hover:opacity-60">
                  WILL YOUR INFORMATION BE SHARED WITH ANYONE?
                </a>
              </NextLink>
            </li>
            <li>
              4.{" "}
              <NextLink href="/privacy#privacy-item-4" preload={false}>
                <a className="text-indigo-800 dark:text-indigo-200 hover:opacity-60">
                  DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?
                </a>
              </NextLink>
            </li>
            <li>
              5.{" "}
              <NextLink href="/privacy#privacy-item-5" preload={false}>
                <a className="text-indigo-800 dark:text-indigo-200 hover:opacity-60">
                  IS YOUR INFORMATION TRANSFERRED INTERNATIONALLY?
                </a>
              </NextLink>
            </li>
            <li>
              6.{" "}
              <NextLink href="/privacy#privacy-item-6" preload={false}>
                <a className="text-indigo-800 dark:text-indigo-200 hover:opacity-60">
                  HOW LONG DO WE KEEP YOUR INFORMATION?
                </a>
              </NextLink>
            </li>
            <li>
              7.{" "}
              <NextLink href="/privacy#privacy-item-7" preload={false}>
                <a className="text-indigo-800 dark:text-indigo-200 hover:opacity-60">
                  HOW DO WE KEEP YOUR INFORMATION SAFE?
                </a>
              </NextLink>
            </li>
            <li>
              8.{" "}
              <NextLink href="/privacy#privacy-item-8" preload={false}>
                <a className="text-indigo-800 dark:text-indigo-200 hover:opacity-60">
                  WHAT ARE YOUR PRIVACY RIGHTS?
                </a>
              </NextLink>
            </li>
            <li>
              9.{" "}
              <NextLink href="/privacy#privacy-item-9" preload={false}>
                <a className="text-indigo-800 dark:text-indigo-200 hover:opacity-60">
                  CONTROLS FOR DO-NOT-TRACK FEATURES
                </a>
              </NextLink>
            </li>
            <li>
              10.{" "}
              <NextLink href="/privacy#privacy-item-10" preload={false}>
                <a className="text-indigo-800 dark:text-indigo-200 hover:opacity-60">
                  DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?
                </a>
              </NextLink>
            </li>
            <li>
              11.{" "}
              <NextLink href="/privacy#privacy-item-11" preload={false}>
                <a className="text-indigo-800 dark:text-indigo-200 hover:opacity-60">
                  DO WE MAKE UPDATES TO THIS NOTICE?
                </a>
              </NextLink>
            </li>
            <li>
              12.{" "}
              <NextLink href="/privacy#privacy-item-12" preload={false}>
                <a className="text-indigo-800 dark:text-indigo-200 hover:opacity-60">
                  HOW CAN YOU CONTACT US ABOUT THIS NOTICE?
                </a>
              </NextLink>
            </li>
          </ul>
        </div>
        <div className="space-y-8 max-w-screen">
          <div id="privacy-item-1" className="space-y-2">
            <h3 className="text-2xl text-center">
              1. WHAT INFORMATION DO WE COLLECT?
            </h3>
            <h4 className="text-xl text-center">
              Information automatically collected
            </h4>
            <p>
              <strong>tl;dr</strong> 
              <span className="underline">
                Some information — such as your Internet Protocol (IP) address
                and/or browser and device characteristics — is collected
                automatically when you visit our Website.
              </span>
            </p>
            <p>
              We automatically collect certain information when you visit, use
              or navigate the Website. This information does not reveal your
              specific identity (like your name or contact information) but may
              include device and usage information, such as your IP address,
              browser and device characteristics, operating system, language
              preferences, referring URLs, device name, country, location,
              information about how and when you use our Website and other
              technical information. This information is primarily needed to
              maintain the security and operation of our Website, and for our
              internal analytics and reporting purposes.
            </p>
            <p>
              Like many businesses, we also collect information through cookies
              and similar technologies.
            </p>
            <p>The information we collect includes:</p>
            <ul className="ml-12 space-y-2">
              <li>
                <span className="underline">Log and Usage Data.</span> Log and
                usage data is service-related, diagnostic, usage and performance
                information our servers automatically collect when you access or
                use our Website and which we record in log files. Depending on
                how you interact with us, this log data may include your IP
                address, device information, browser type and settings and
                information about your activity in the Website (such as the
                date/time stamps associated with your usage, pages and files
                viewed, searches and other actions you take such as which
                features you use), device event information (such as system
                activity, error reports (sometimes called &apos;crash
                dumps&apos;) and hardware settings).
              </li>
              <li>
                <span className="underline">Device Data.</span> We collect
                device data such as information about your computer, phone,
                tablet or other device you use to access the Website. Depending
                on the device used, this device data may include information
                such as your IP address (or proxy server), device and
                application identification numbers, location, browser type,
                hardware model Internet service provider and/or mobile carrier,
                operating system and system configuration information.
              </li>
              <li>
                <span className="underline">Location Data.</span> We collect
                location data such as information about your device&apos;s
                location, which can be either precise or imprecise. How much
                information we collect depends on the type and settings of the
                device you use to access the Website. For example, we may use
                GPS and other technologies to collect geolocation data that
                tells us your current location (based on your IP address). You
                can opt out of allowing us to collect this information either by
                refusing access to the information or by disabling your Location
                setting on your device. Note however, if you choose to opt out,
                you may not be able to use certain aspects of the Services.
              </li>
            </ul>
            <h4 className="text-xl text-center">
              Information collected from other sources
            </h4>
            <p>
              <strong>tl;dr</strong>  
              <span className="underline">
                We may collect limited data from public databases, marketing
                partners, and other outside sources.
              </span>
            </p>
            <p>
              In order to enhance our ability to provide relevant marketing,
              offers and services to you and update our records, we may obtain
              information about you from other sources, such as public
              databases, joint marketing partners, affiliate programs, data
              providers, as well as from other third parties. This information
              includes mailing addresses, job titles, email addresses, phone
              numbers, intent data (or user behavior data), Internet Protocol
              (IP) addresses, social media profiles, social media URLs and
              custom profiles, for purposes of targeted advertising and event
              promotion.
            </p>
          </div>
          <div id="privacy-item-2" className="space-y-2 ">
            <h3 className="text-2xl text-center">
              2. HOW DO WE USE YOUR INFORMATION?
            </h3>

            <p>
              <strong>tl;dr</strong>  
              <span className="underline">
                We process your information for purposes based on legitimate
                business interests, the fulfillment of our contract with you,
                compliance with our legal obligations, and/or your consent.
              </span>
            </p>
            <p>
              We use personal information collected via our Website for a
              variety of business purposes described below. We process your
              personal information for these purposes in reliance on our
              legitimate business interests, in order to enter into or perform a
              contract with you, with your consent, and/or for compliance with
              our legal obligations. We indicate the specific processing grounds
              we rely on next to each purpose listed below.
            </p>
            <p>We use the information we collect or receive:</p>
            <ul className="ml-12 space-y-2">
              <li>
                <strong>To send administrative information to you.</strong> We
                may use your personal information to send you product, service
                and new feature information and/or information about changes to
                our terms, conditions, and policies.
              </li>
              <li>
                <strong>To protect our Services.</strong> We may use your
                information as part of our efforts to keep our Website safe and
                secure (for example, for fraud monitoring and prevention).
              </li>
              <li>
                <strong>
                  To enforce our terms, conditions and policies for business
                  purposes, to comply with legal and regulatory requirements or
                  in connection with our contract.
                </strong>
              </li>
              <li>
                <strong>To respond to legal requests and prevent harm.</strong>
                 If we receive a subpoena or other legal request, we may need to
                inspect the data we hold to determine how to respond.
              </li>
              <li>
                <strong>
                  To send you marketing and promotional communications.
                </strong>
                 We and/or our third-party marketing partners may use the
                personal information you send to us for our marketing purposes,
                if this is in accordance with your marketing preferences. For
                example, when expressing an interest in obtaining information
                about us or our Website, subscribing to marketing or otherwise
                contacting us, we will collect personal information from you.
                You can opt-out of our marketing emails at any time (see the
                section{" "}
                <NextLink href="/privacy#privacy-item-8" preload={false}>
                  <a className="text-indigo-800 dark:text-indigo-200 hover:opacity-60">
                    &quot;WHAT ARE YOUR PRIVACY RIGHTS?&quot;
                  </a>
                </NextLink>{" "}
                below).
              </li>
              <li>
                <strong>Deliver targeted advertising to you.</strong> We may use
                your information to develop and display personalized content and
                advertising (and work with third parties who do so) tailored to
                your interests and/or location and to measure its effectiveness.
              </li>
              <li>
                <strong>For other business purposes.</strong> We may use your
                information for other business purposes, such as data analysis,
                identifying usage trends, determining the effectiveness of our
                promotional campaigns and to evaluate and improve our Website,
                products, marketing and your experience. We may use and store
                this information in aggregated and anonymized form so that it is
                not associated with individual end users and does not include
                personal information. We will not use identifiable personal
                information without your consent.
              </li>
            </ul>
          </div>
          <div id="privacy-item-3" className="space-y-2">
            <h3 className="text-2xl text-center">
              3. WILL YOUR INFORMATION BE SHARED WITH ANYONE?
            </h3>
            <p>
              <strong>tl;dr</strong> 
              <span className="underline">
                We only share information with your consent, to comply with
                laws, to provide you with services, to protect your rights, or
                to fulfill business obligations.
              </span>
            </p>
            <p>
              We may process or share your data that we hold based on the
              following legal basis:
            </p>
            <ul className="ml-12 space-y-2">
              <li>
                <strong>Consent</strong>: We may process your data if you have
                given us specific consent to use your personal information for a
                specific purpose.
              </li>
              <li>
                <strong>Legitimate Interests</strong>: We may process your data
                when it is reasonably necessary to achieve our legitimate
                business interests.
              </li>
              <li>
                <strong>Performance of a Contract</strong>: Where we have
                entered into a contract with you, we may process your personal
                information to fulfill the terms of our contract.
              </li>
              <li>
                <strong>Legal Obligations</strong>: We may disclose your
                information where we are legally required to do so in order to
                comply with applicable law, governmental requests, a judicial
                proceeding, court order, or legal process, such as in response
                to a court order or a subpoena (including in response to public
                authorities to meet national security or law enforcement
                requirements).
              </li>
              <li>
                <strong>Vital Interests</strong>: We may disclose your
                information where we believe it is necessary to investigate,
                prevent, or take action regarding potential violations of our
                policies, suspected fraud, situations involving potential
                threats to the safety of any person and illegal activities, or
                as evidence in litigation in which we are involved.
              </li>
            </ul>
          </div>
          <div id="privacy-item-4" className="space-y-2">
            <h3 className="text-2xl text-center">
              4. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?
            </h3>
            <p>
              <strong>tl;dr</strong> 
              <span className="underline">
                We may use cookies and other tracking technologies to collect
                and store your information.
              </span>
            </p>
            <p>
              We may use cookies and similar tracking technologies (like web
              beacons and pixels) to access or store information.
            </p>
            <p>
              Specific information about how we use such technologies and how
              you can refuse certain cookies is set out in our{" "}
              <NextLink href="/privacy/cookies">
                <a className="text-indigo-800 dark:text-indigo-200 hover:opacity-60">
                  Cookie Notice
                </a>
              </NextLink>
              .
            </p>
          </div>
          <div id="privacy-item-5" className="space-y-2">
            <h3 className="text-2xl text-center">
              5. IS YOUR INFORMATION TRANSFERRED INTERNATIONALLY?
            </h3>
            <p>
              <strong>tl;dr</strong>  
              <span className="underline">
                We may transfer, store, and process your information in
                countries other than your own.
              </span>
            </p>
            <p>We use a hosting service with servers located worldwide.</p>
            <p>
              If you are a resident in the European Economic Area (EEA) or
              United Kingdom (UK), then these countries may not necessarily have
              data protection laws or other similar laws as comprehensive as
              those in your country. We will however take all necessary measures
              to protect your personal information in accordance with this
              privacy notice and applicable law.
            </p>
          </div>
          <div id="privacy-item-6" className="space-y-2">
            <h3 className="text-2xl text-center">
              6. HOW LONG DO WE KEEP YOUR INFORMATION?
            </h3>
            <p>
              <strong>tl;dr</strong> 
              <span className="underline">
                We keep your information for as long as necessary to fulfill the
                purposes outlined in this privacy notice unless otherwise
                required by law.
              </span>
            </p>
            <p>
              We will only keep your personal information for as long as it is
              necessary for the purposes set out in this privacy notice, unless
              a longer retention period is required or permitted by law (such as
              tax, accounting or other legal requirements). No purpose in this
              notice will require us keeping your personal information for
              longer than 90 days.
            </p>
            <p>
              When we have no ongoing legitimate business need to process your
              personal information, we will either delete or anonymize such
              information, or, if this is not possible (for example, because
              your personal information has been stored in backup archives),
              then we will securely store your personal information and isolate
              it from any further processing until deletion is possible.
            </p>
          </div>
          <div id="privacy-item-7" className="space-y-2">
            <h3 className="text-2xl text-center">
              7. HOW DO WE KEEP YOUR INFORMATION SAFE?
            </h3>
            <p>
              <strong>tl;dr</strong> 
              <span className="underline">
                We aim to protect your personal information through a system of
                organizational and technical security measures.
              </span>
            </p>
            <p>
              We have implemented appropriate technical and organizational
              security measures designed to protect the security of any personal
              information we process. However, despite our safeguards and
              efforts to secure your information, no electronic transmission
              over the Internet or information storage technology can be
              guaranteed to be 100% secure, so we cannot promise or guarantee
              that hackers, cybercriminals, or other unauthorized third parties
              will not be able to defeat our security, and improperly collect,
              access, steal, or modify your information. Although we will do our
              best to protect your personal information, transmission of
              personal information to and from our Website is at your own risk.
              You should only access the Website within a secure environment.
            </p>
          </div>
          <div id="privacy-item-8" className="space-y-2">
            <h3 className="text-2xl text-center ">
              8. WHAT ARE YOUR PRIVACY RIGHTS?
            </h3>
            <p>
              <strong>tl;dr</strong>  
              <span className="underline">
                You may review, change, or terminate your account at any time.
              </span>
            </p>
            <p>
              If you are a resident in the EEA or UK and you believe we are
              unlawfully processing your personal information, you also have the
              right to complain to your local data protection supervisory
              authority. You can find their contact details here:{" "}
              <NextLink
                href="http://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm"
                rel="external nofollow"
                preload={false}
              >
                <a className="text-indigo-800 dark:text-indigo-200 hover:opacity-60">
                  http://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm
                </a>
              </NextLink>
              .
            </p>
            <p>
              If you are a resident in Switzerland, the contact details for the
              data protection authorities are available here:{" "}
              <NextLink
                href="https://www.edoeb.admin.ch/edoeb/en/home.html"
                rel="external nofollow"
                preload={false}
              >
                <a className="text-indigo-800 dark:text-indigo-200 hover:opacity-60">
                  https://www.edoeb.admin.ch /edoeb/en/home.html
                </a>
              </NextLink>
              .
            </p>
            <p>
              Cookies and similar technologies: Most Web browsers are set to
              accept cookies by default. If you prefer, you can usually choose
              to set your browser to remove cookies and to reject cookies. If
              you choose to remove cookies or reject cookies, this could affect
              certain features or services of our Website. To opt-out of
              interest-based advertising by advertisers on our Website visit{" "}
              <NextLink
                href="http://www.aboutads.info/choices/"
                rel="external nofollow"
                preload={false}
              >
                <a className="text-indigo-800 dark:text-indigo-200 hover:opacity-60">
                  http://www.aboutads.info/choices/
                </a>
              </NextLink>
              .
            </p>
          </div>
          <div id="privacy-item-9" className="p-4 space-y-2">
            <h3 className="text-2xl text-center">
              9. CONTROLS FOR DO-NOT-TRACK FEATURES
            </h3>
            <p>
              Most web browsers and some mobile operating systems and mobile
              applications include a Do-Not-Track (&quot;DNT&quot;) feature or
              setting you can activate to signal your privacy preference not to
              have data about your online browsing activities monitored and
              collected. At this stage no uniform technology standard for
              recognizing and implementing DNT signals has been finalized. As
              such, we do not currently respond to DNT browser signals or any
              other mechanism that automatically communicates your choice not to
              be tracked online. If a standard for online tracking is adopted
              that we must follow in the future, we will inform you about that
              practice in a revised version of this privacy notice.
            </p>
          </div>
          <div id="privacy-item-10" className="p-4 space-y-2">
            <h3 className="text-2xl text-center">
              10. DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?
            </h3>
            <p>
              <strong>tl;dr</strong>  
              <span className="underline">
                Yes, if you are a resident of California, you are granted
                specific rights regarding access to your personal information.
              </span>
            </p>
            <p>
              California Civil Code Section 1798.83, also known as the
              &quot;Shine The Light&quot; law, permits our users who are
              California residents to request and obtain from us, once a year
              and free of charge, information about categories of personal
              information (if any) we disclosed to third parties for direct
              marketing purposes and the names and addresses of all third
              parties with which we shared personal information in the
              immediately preceding calendar year. If you are a California
              resident and would like to make such a request, please submit your
              request in writing to us using the contact information provided
              below.
            </p>
            <p>
              If you are under 18 years of age, reside in California, and have a
              registered account with the Website, you have the right to request
              removal of unwanted data that you publicly post on the Website. To
              request removal of such data, please contact us using the contact
              information provided below, and include the email address
              associated with your account and a statement that you reside in
              California. We will make sure the data is not publicly displayed
              on the Website, but please be aware that the data may not be
              completely or comprehensively removed from all our systems (e.g.
              backups, etc.).
            </p>
          </div>
          <div id="privacy-item-11" className="p-4 space-y-2">
            <h3 className="text-2xl text-center">
              11. DO WE MAKE UPDATES TO THIS NOTICE?
            </h3>
            <p>
              <strong>tl;dr</strong>  
              <span className="underline">
                Yes, we will update this notice as necessary to stay compliant
                with relevant laws.
              </span>
            </p>
            <p>
              We may update this privacy notice from time to time. The updated
              version will be indicated by an updated &quot;Revised&quot; date
              and the updated version will be effective as soon as it is
              accessible. If we make material changes to this privacy notice, we
              may notify you either by prominently posting a notice of such
              changes or by directly sending you a notification. We encourage
              you to review this privacy notice frequently to be informed of how
              we are protecting your information.
            </p>
          </div>
          <div id="privacy-item-12" className="p-4 space-y-2">
            <h3 className="text-2xl text-center">
              12. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?
            </h3>
            <p>
              If you have questions or comments about this notice, you
              may contact our Data Protection Officer (DPO), 
              <strong>
                {" "}
                {process.env.NEXT_PUBLIC_OG_PROFILE_FIRST_NAME}{" "}
                {process.env.NEXT_PUBLIC_OG_PROFILE_LAST_NAME}
              </strong>
              , by email at 
              <strong>
                <Email className="text-indigo-800 dark:text-indigo-200 hover:opacity-60" />
              </strong>
              .
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
